import { DefaultNotificationItem } from "./default";
import { MentionNotificationItem } from "./mentions";
import { ReplyNotificationItem } from "./replies";
import type { NotificationItemProps } from "./layout";

export function NotificationItem({ notification }: NotificationItemProps) {
  switch (notification.category) {
    case "mentions":
      return <MentionNotificationItem notification={notification} />;
    case "replies":
    case "sequence_replies":
      return <ReplyNotificationItem notification={notification} />;
    default:
      return <DefaultNotificationItem notification={notification} />;
  }
}

export { NotificationItemLayout } from "./layout";
